import { render, staticRenderFns } from "./LangButton.vue?vue&type=template&id=a8bba2f2&scoped=true"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"
import style0 from "./LangButton.vue?vue&type=style&index=0&id=a8bba2f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bba2f2",
  null
  
)

export default component.exports